<template>
  <div>
    <div class="float-left mr-1" style="width:300px;">
      <font-awesome-icon :icon="entityData.tpi_type== 'O' ? 'building' : 'male'" class="mr-2" />
      <strong>{{entityData.comp_name_eng}}</strong>
      (Third Party)
      <font-awesome-icon
        v-if="totalEntityAlerts > 0"
        class="text-danger ml-3"
        icon="exclamation-triangle"
      />

      ({{totalEntityAlerts}})
    </div>

    <span v-if="totalEntityAlerts == 0">
      <b-badge variant="success">No Alerts</b-badge>
    </span>
    <span>
      <b-badge variant="success" class="mr-3">Negative Alerts: {{negativeAlerts.length}}</b-badge>
    </span>
    <span>
      <b-badge variant="danger">Positive Alerts: {{positiveAlerts.length}}</b-badge>
    </span>
    <span>
      <b-badge variant="warning" class="ml-2">Pending: {{pendingAlerts}}</b-badge>
    </span>
    <span v-if="negativeAlerts.length == 0 && positiveAlerts.length == 0">
      <b-badge variant="warning" class="ml-2">Status: Pending</b-badge>
    </span>
    <span v-else>
      <b-badge
        v-if="negativeAlerts.length > 0"
        variant="success"
        class="ml-2"
      >Status: Remediated Green</b-badge>
      <b-badge v-else variant="danger" class="ml-2">Status: Remediated Red</b-badge>
    </span>

    <!--    <span>-->
    <!--      <b-badge variant="danger">PEP</b-badge>-->
    <!--      -->
    <!--    </span>-->
    <!--    <span class="f-circle">R</span>-->
    <b-button
      v-if="totalEntityAlerts >0"
      @click="collapse = !collapse"
      variant="primary"
      size="sm"
      class="float-right"
    >
      <font-awesome-icon :icon="collapse ? 'minus' : 'plus'" />
    </b-button>
    <div class="clearfix"></div>
    <b-collapse id="collapse-1" class="mt-2" v-model="collapse">
      <b-card>
        <b-tabs content-class="mt-3">
          <b-tab active>
            <template v-slot:title>
              <font-awesome-icon class="text-danger" icon="exclamation-triangle" />
              Alerts ({{totalEntityAlerts}})
            </template>
            <rdc-alert
              v-for="(alert,alertIndex) in entityData.srch_tpi_rdc_indivi_alrt"
              :alert="alert"
              :alertIndex="alertIndex"
              :entityType="entityData.entity_type"
              @getStatus="calculateAlerts"
            ></rdc-alert>
          </b-tab>
          <!--         <b-tab title="Overview"  class="text-left">-->
          <!--            <b-card-group deck>-->
          <!--              <b-card header-tag="header" footer-tag="footer">-->
          <!--                <template v-slot:header>-->
          <!--                  <h6 class="mb-0">Entity Details</h6>-->
          <!--                </template>-->
          <!--                <entity-company-details :entityData="entityData"></entity-company-details>-->
          <!--                -->
          <!--                -->
          <!--              </b-card>-->
          <!--              <b-card title="" header-tag="header" footer-tag="footer">-->
          <!--                <template v-slot:header>-->
          <!--                  <h6 class="mb-0"><font-awesome-icon class="text-danger" icon="exclamation-triangle" /> Post Remediation ({{totalEntityAlerts || 0}})</h6>-->
          <!--                </template>-->
          <!--                -->
          <!--                <p><font-awesome-icon class="text-danger" icon="exclamation-triangle" />&nbsp;Positive Alerts: {{totalEntityAlerts || 0}}</p>-->
          <!--                <p><font-awesome-icon class="text-success" icon="ban" />&nbsp;Negative Alerts: {{totalEntityAlerts || 0}}</p>-->

          <!--                <hr>-->
          <!--                <p>Sources:</p>-->
          <!--                <b-badge class="mr-2" v-for="(source) in riskSources">{{source+' 5'}}</b-badge>-->
          <!--                <hr>-->
          <!--                <p>Categories:</p>-->
          <!--                <b-badge class="mr-2" v-for="(category) in riskCategories">{{category +' 2'}}</b-badge>-->
          <!--                <p>Sub Categories:</p>-->
          <!--                <b-badge class="mr-2" v-for="(subCategory) in riskSubCategories">{{subCategory +' 2'}}</b-badge>-->
          <!--                -->
          <!--              </b-card>-->
          <!--              <b-card header-tag="header" footer-tag="footer">-->
          <!--                <template v-slot:header>-->
          <!--                  <h6 class="mb-0">PRM</h6>-->
          <!--                </template>-->
          <!--                <p><font-awesome-icon class="text-danger" icon="exclamation-triangle" />&nbsp;Positive Alerts: {{totalEntityAlerts || 0}}</p>-->
          <!--                <p><font-awesome-icon class="text-success" icon="ban" />&nbsp;Negative Alerts: {{totalEntityAlerts || 0}}</p>-->
          <!--              </b-card>-->
          <!--              <b-card header-tag="header" footer-tag="footer">-->
          <!--                <template v-slot:header>-->
          <!--                  <h6 class="mb-0">Waldo Match</h6>-->
          <!--                </template>-->
          <!--                <p><font-awesome-icon class="text-danger" icon="exclamation-triangle" />&nbsp;Positive Alerts: {{totalEntityAlerts || 0}}</p>-->
          <!--                <p><font-awesome-icon class="text-success" icon="ban" />&nbsp;Negative Alerts: {{totalEntityAlerts || 0}}</p>-->
          <!--              </b-card>-->
          <!--            -->
          <!--            </b-card-group>-->
          <!--          </b-tab>-->
        </b-tabs>
      </b-card>
    </b-collapse>
  </div>
</template>

<script>
import _ from "lodash";
import { required } from "vuelidate/lib/validators";
import entityCompanyDetails from "./entity-company-details.vue";
import rdcAlert from "./RDCAlert.vue";
import { mapGetters, mapState } from "vuex";
import { EventBus } from "@/event-bus.js";
import moment from "moment";

export default {
  name: "EntityOverview",
  components: {
    entityCompanyDetails,
    rdcAlert
  },
  data() {
    return {
      temp: [],
      // for alerts
      negativeAlerts: [],
      positiveAlerts: [],
      pendingAlerts: 0,
      totalEntityAlerts: 0,

      // for sec count
      secUniqueCount: 0,
      uniqueCategories: [],
      uniqueSubCategories: [],

      remediationStatus: null,
      collapse: false,
      date: null,
      riskCategories: [],
      riskSubCategories: ["EFG", "HIJ", "LMN", "OPQ", "RST"],
      riskSources: ["RiskConnect", "OFAC", "Factiva", "Bloomsberg"]
    };
  },
  created() {},
  mounted() {
    // // console.log("this.entityData", this.entityData)
    // getUniqueSubCategories();
    if (
      this.entityData.srch_tpi_rdc_indivi_alrt &&
      this.entityData.srch_tpi_rdc_indivi_alrt.length
    ) {
      // this.getUniqueCategories(this.entityData.srch_tpi_rdc_indivi_alrt);
      this.pendingAlerts = this.entityData.srch_tpi_rdc_indivi_alrt.length;
      this.totalEntityAlerts = this.entityData.srch_tpi_rdc_indivi_alrt.length;
    }
  },
  validations: {},
  computed: {
    ...mapGetters([]),
    ...mapState(["toggleAllCoppalse"])
  },
  watch: {
    toggleAllCoppalse(value) {
      this.collapse = value;
    }
  },
  methods: {
    //     getUniqueCategories(array){
    //         let uniqueCategoryArray = [];
    //         let uniqueSubCategoryArray = [];
    //         // Loop through array values
    //         for(let alert of array){
    //             // // console.log("category", alert.ent_evnt)
    //             let aa = JSON.parse(alert.ent_evnt)
    //            aa.map(category =>{
    //             //  // console.log("category", category.category)
    //               if(uniqueCategoryArray.indexOf(category.category) === -1){
    //                 uniqueCategoryArray.push(category.category);
    //             }else{
    //               let counts = {};
    //               aa.forEach(function(x) { counts[x.category] = (counts[x.category] || 0)+1; });
    //               // console.log("counys", counts)
    //             }
    //              if(uniqueSubCategoryArray.indexOf(category.subCategory) === -1){
    //                 uniqueSubCategoryArray.push(category.subCategory);
    //             }
    //            })

    //         }
    //         this.uniqueCategories = uniqueCategoryArray;
    //         this.uniqueSubCategories = uniqueSubCategoryArray;
    //         // // console.log("uniqueArray", uniqueArray)
    //         // return uniqueArray;
    // },
    calculateAlerts(status, alert) {
      switch (status) {
        case "postive alert":
          // code block

          this.positiveAlerts.push(alert.id);
          let negativeIndex = this.negativeAlerts.indexOf(alert.id);
          if (negativeIndex != -1) {
            this.negativeAlerts.splice(
              this.negativeAlerts.indexOf(alert.id),
              1
            );
            this.$store.state.totalPositiveAlerts -= 1;
          }
          this.pendingAlerts =
            this.totalEntityAlerts -
            (this.positiveAlerts.length + this.negativeAlerts.length);
          this.$store.state.totalPositiveAlerts += 1; // sum of all positive alerts
          // this.$store.state.totalPendingAlerts = (this.$store.state.totalAlerts -  this.totalEntityAlerts) + this.pendingAlerts // calculatin total pending alets
          this.$store.state.totalRemidiatedAlerts =
            this.positiveAlerts.length + this.negativeAlerts.length; // calculatin total remediation alets
          this.$store.state.totalPendingAlerts =
            this.$store.state.totalAlerts -
            this.$store.state.totalRemidiatedAlerts; // calculatin total pending alets

          break;

        case "negative alert":
          this.negativeAlerts.push(alert.id);
          let positiveIndex = this.positiveAlerts.indexOf(alert.id);
          if (positiveIndex != -1) {
            this.positiveAlerts.splice(
              this.positiveAlerts.indexOf(alert.id),
              1
            );
            this.$store.state.totalNegativeAlerts -= 1;
          }
          this.pendingAlerts =
            this.totalEntityAlerts -
            (this.positiveAlerts.length + this.negativeAlerts.length);
          this.$store.state.totalNegativeAlerts += 1; // sum of all negative alerts
          // this.$store.state.totalPendingAlerts = (this.$store.state.totalAlerts -  this.totalEntityAlerts) + this.pendingAlerts // calculatin total pending alets
          this.$store.state.totalRemidiatedAlerts =
            this.$store.state.totalPositiveAlerts +
            this.$store.state.totalNegativeAlerts; // calculatin total remediation alets
          this.$store.state.totalPendingAlerts =
            this.$store.state.totalAlerts -
            this.$store.state.totalRemidiatedAlerts; // calculatin total pending alets

          // code block
          break;
        case "pending":
          if (this.negativeAlerts.indexOf(alert.id) != -1) {
            this.negativeAlerts.splice(
              this.negativeAlerts.indexOf(alert.id),
              1
            );
            this.$store.state.totalNegativeAlerts -= 1;
          }
          if (this.positiveAlerts.indexOf(alert.id) != -1) {
            this.positiveAlerts.splice(
              this.positiveAlerts.indexOf(alert.id),
              1
            );
            this.$store.state.totalPositiveAlerts -= 1;
          }
          this.pendingAlerts =
            this.totalEntityAlerts -
            (this.positiveAlerts.length + this.negativeAlerts.length);
          // this.$store.state.totalPendingAlerts = (this.$store.state.totalAlerts -  this.totalEntityAlerts) + this.pendingAlerts // calculatin total pending alets
          // this.$store.state.totalRemidiatedAlerts = this.positiveAlerts.length +  this.negativeAlerts.length  // calculatin total remediation alets
          this.$store.state.totalRemidiatedAlerts =
            this.$store.state.totalPositiveAlerts +
            this.$store.state.totalNegativeAlerts; // calculatin total remediation alets
          this.$store.state.totalPendingAlerts =
            this.$store.state.totalAlerts -
            this.$store.state.totalRemidiatedAlerts; // calculatin total pending alets

        default:
        // code block
      }
    }
  },
  props: {
    entityData: {
      type: Object,
      default: function() {
        return {
          srch_tpi_rdc_indivi_alrt: []
        };
      }
    }
  }
};
</script>

<style>
.f-circle {
  font-family: Arial;
  /* your font family here! */
  font-weight: bold;

  border-radius: 50%;
  background-color: red;
  display: inline-block;
  padding: 4px;
  width: 30px;
  height: 30px;
  vertical-align: middle;
  color: white;
}
</style>
